// Emotion types
/// <reference types="@emotion/react/types/css-prop" />
import { css } from "@emotion/react";
import styled from "@emotion/styled";
// Subtitles
import campaignSubs from "file-loader!../assets/subtitles/campaign.vtt";
import React, { useRef, useEffect, useState } from "react";

// Images
import datacenter from "../assets/images/datacenter.jpg";
import eFerry from "../assets/images/e-ferry.jpg";
import transportTruck from "../assets/images/transport-truck.jpg";
import solar from "../assets/images/solar.jpg";
import vfSun from "../assets/images/vfSun.png";
import wind from "../assets/images/wind.jpg";
import emobility from "../assets/images/emobility.jpg";
import snowmobile from "../assets/images/snowmobile.jpg";
import aviation from "../assets/images/aviation.jpg";

// Video
import oceanWebM from "../assets/videos/ocean.webm";
import oceanMp4 from "../assets/videos/ocean.mp4";

import campaignMp4 from "../assets/videos/campaign.mp4";
import campaignWebM from "../assets/videos/campaign.webm";
import cloudsMp4 from "../assets/videos/clouds.mp4";
import cloudsWebM from "../assets/videos/clouds.webm";
import steelMp4 from "../assets/videos/steel.mp4";
import steelWebm from "../assets/videos/steel.webm";

import {
    Button,
    Case,
    Footer,
    Headline,
    HeroText,
    Layout,
    Map,
    Metadata,
    Navigation,
    StandOutImage,
    VideoHero,
    locationsSwedish,
} from "../components";


// Styling

const StickyBtn = styled.a`
    position: sticky;
    top: 80px;
    z-index: 10;
`;

// Markup
export const Swedish = () => {
    const steelRef = useRef<HTMLDivElement>(null);
    const roadRef = useRef<HTMLDivElement>(null);
    const emobilityRef = useRef<HTMLDivElement>(null);
    const ferryRef = useRef<HTMLDivElement>(null);
    const datacenterRef = useRef<HTMLDivElement>(null);
    const aviationRef = useRef<HTMLDivElement>(null);
    const oceanRef = useRef<HTMLDivElement>(null);
    const solarRef = useRef<HTMLDivElement>(null);
    const snowmobileRef = useRef<HTMLDivElement>(null);

    const [zoom, setZoom] = useState(4.2);

    useEffect(() => {
        window.innerWidth > 768 ? setZoom(4.2) : setZoom(3.3);
    }, [zoom]);

    // Order important for scrollTo, same as array of map-markers
    const articleRefs = [
        steelRef,
        oceanRef,
        aviationRef,
        solarRef,
        emobilityRef,
        snowmobileRef,
        roadRef,
        datacenterRef,
        ferryRef,
    ];

    return (
        <>
            <Metadata />
            <Navigation />
            <Layout>
                <VideoHero
                    primary
                    webM={campaignWebM}
                    mp4={campaignMp4}
                    subtitles={campaignSubs}
                    subLang="sv"
                    subLabel="Svenska"
                >
                    {/*<h1>Bli en del av bra saker för klimatet</h1>*/}
                </VideoHero>
                <StickyBtn
                    target="_blank"
                    rel="noreferrer"
                    href="https://www.vattenfall.se/elavtal/?icmp=301/teckna-elavtal/Teckna%20elavtal%20-%20Vattenfall"
                >
                    <Button intent="primary">Teckna fossilfritt elavtal</Button>
                </StickyBtn>
                <VideoHero webM={oceanWebM} mp4={oceanMp4}>
                    <HeroText color="#fff">
                        Du blir en del av vägen mot en fossilfri morgondag med
                        ditt elavtal.
                    </HeroText>
                </VideoHero>
                <Headline
                    primary="Bra saker på väg"
                    secondary="Saker vi gör idag så du kan leva fossilfritt imorgon."
                />
                <Map articleRefs={articleRefs} data={locationsSwedish} zoom={zoom} />

                <VideoHero
                    webM={steelWebm}
                    mp4={steelMp4}
                    ref={steelRef}
                    primary
                ></VideoHero>

                <div style={{ maxWidth: "620px", textAlign: "center" }}>
                    <h2>
                        Fossilfritt stål kan minska världens koldioxidutsläpp
                        med 7%
                    </h2>

                    <div style={{ marginTop: "35px" }}>
                        <a
                            target="_blank"
                            rel="noreferrer"
                            href="https://www.vattenfall.se/fokus/trender-och-innovation/hybrit-fossilfri-stalproduktion/"
                        >
                            <Button intent="primary">Läs mer</Button>
                        </a>
                    </div>
                </div>

                <Case
                    ref={oceanRef}
                    image={wind}
                    imageOn="right"
                    offset={50}
                    backgroundColor="#EDF1F6"
                >
                    <h4>Kraft från havet</h4>
                    <p>
                        Det görs stora framsteg när det gäller energi från
                        vinden. Flytande vindkraft är en ny möjlighet för ett
                        fossilfritt liv.
                    </p>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.vattenfall.se/fokus/hallbarhet/flytande-vindkraft/"
                    >
                        Läs mer
                    </a>
                </Case>
                <Case
                    ref={aviationRef}
                    image={aviation}
                    imageOn="left"
                    offset={50}
                    backgroundColor="#EDF1F6"
                >
                    <h4>Fossilfritt flyg</h4>
                    <p>
                        I takt med att fossilfritt elektrobränsle utvecklas,
                        blir det allt lättare att flyga med gott samvete.
                    </p>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.vattenfall.se/fokus/trender-och-innovation/fossilfritt-flyg/"
                    >
                        Läs mer
                    </a>
                </Case>
                <Case
                    ref={solarRef}
                    image={solar}
                    imageOn="right"
                    offset={50}
                    backgroundColor="#F2F2F2"
                >
                    <h4>Växande solkraft</h4>
                    <p>
                        Solpaneler är en allt vanligare syn. Och fler och fler
                        hem är samtidigt kraftverk som tar till vara den fria
                        energin från solen.
                    </p>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.vattenfall.se/fokus/solceller/ekohuset-solenergi/"
                    >
                        Läs mer
                    </a>
                    <StandOutImage src={vfSun} />
                </Case>
                <Case
                    ref={emobilityRef}
                    image={emobility}
                    imageOn="left"
                    offset={50}
                    backgroundColor="#EDF1F6"
                >
                    <h4>Fler laddstationer</h4>
                    <p>
                        Utvecklingen går framåt med laddlösningar och
                        laddstationer för elbilarna som blir allt fler. Snart
                        kan också biltillverkningen i sig bli fossilfri.
                    </p>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.vattenfall.se/fokus/eldrivna-transporter/framtidens-bilkorning/"
                    >
                        Läs mer
                    </a>
                </Case>
                <Case
                    ref={snowmobileRef}
                    image={snowmobile}
                    imageOn="right"
                    offset={50}
                    backgroundColor="#EDF1F6"
                >
                    <h4>Eldrivna snöskotrar</h4>
                    <p>
                        Tänk dig att glida fram ljudlöst i vildmarken, över
                        frusna sjöar och vida fjäll. Det är fullt möjligt med de
                        eldrivna snöskotrarna som nu har kommit ut på marknaden.
                    </p>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.vattenfall.se/fokus/eldrivna-transporter/off-road-pa-el/"
                    >
                        Läs mer
                    </a>
                </Case>
                <Case
                    ref={roadRef}
                    image={transportTruck}
                    imageOn="left"
                    offset={50}
                    backgroundColor="#F2F2F2"
                >
                    <h4>Trådlösa elvägar</h4>
                    <p>
                        Världens första trådlösa elväg för tunga lastbilar och
                        bussar är invigd. Det går nu att köra tunga transporter
                        mellan flygplatsen och Visby helt på el.
                    </p>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.vattenfall.se/fokus/eldrivna-transporter/elektriska-vagar/"
                    >
                        Läs mer
                    </a>
                </Case>
                <Case
                    ref={datacenterRef}
                    image={datacenter}
                    imageOn="right"
                    offset={50}
                    backgroundColor="#F2F2F2"
                >
                    <h4>Fossilfria datacenter</h4>
                    <p>
                        Allt fler globala leverantörer av digitala tjänster
                        väljer att placera sina datacenter i norra Sverige, i
                        serverhallar som drivs av fossilfri el.
                    </p>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.vattenfall.se/fokus/hallbarhet/fossilfria-datacenter/"
                    >
                        Läs mer
                    </a>
                </Case>
                <Case
                    ref={ferryRef}
                    image={eFerry}
                    imageOn="left"
                    offset={50}
                    backgroundColor="#EDF1F6"
                >
                    <h4>Eldriven sjötrafik</h4>
                    <p>
                        Sedan ett par år trafikerar elhybridfärjan E/S Movitz
                        Mälaren i Stockholm. Färjan tar tio minuter att ladda
                        för en timmes trafik.
                    </p>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.vattenfall.se/fokus/eldrivna-transporter/elfarjan-es-movitz/"
                    >
                        Läs mer
                    </a>
                </Case>
                <VideoHero webM={cloudsWebM} mp4={cloudsMp4} minHeight>
                    <h2>Förnybar eller fossilfri el?</h2>
                    <div
                        css={css`
                            max-width: 705px;
                        `}
                    >
                        <HeroText small color="#fff">
                            All el vi säljer i Sverige är fossilfri. Det innebär
                            att elen produceras i princip helt utan utsläpp av
                            koldioxid. Vissa energislag är dessutom förnybara.
                            Vattenkraft, solkraft och vindkraft produceras med
                            energikällor som inte tar slut. Kärnkraft produceras
                            av uran, som inte är en outsinlig källa även om
                            energin som utvinns är mycket effektiv.
                        </HeroText>
                        <HeroText small color="#fff">
                            Om du vill, kan du välja ett specifikt energislag
                            till ditt elavtal.
                        </HeroText>
                        <HeroText small color="#fff">
                            Det kostar inget extra.
                        </HeroText>
                    </div>
                    <a
                        target="_blank"
                        rel="noreferrer"
                        href="https://www.vattenfall.se/elavtal/energikallor/"
                    >
                        <Button intent="secondary">
                            Läs mer om energikällorna
                        </Button>
                    </a>
                </VideoHero>
            </Layout>
            <Footer />
        </>
    );
};
